import React, { Component } from "react";
import { Dropdown, Image, Table } from "semantic-ui-react";
import _ from "lodash";
import SearchFormTemplate from "./SearchFormTemplate";
import SearchIcon from "../../assets/images/search_black_37x37.png";

class SearchLeftForms extends Component {
  constructor(props) {
    super(props);
    this.loadData(props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  getSelectedForm = (selectedFormId) => {
    let selectedForm;
    _.forEach(this.props.newFormsData, (formsData, index) => {
      const formId = formsData[0].FormId;
      const searchFormsData = this.props.searchFormsData;
      if (selectedFormId === formId) {
        selectedForm = (
          <SearchFormTemplate
            key={`Form_${formId}_${index}`}
            formId={formId}
            formControls={formsData}
            style={{ padding: "5px" }}
            {...this.props}
            isLeftSearch
            defaultFormData={searchFormsData[`Form_${formId}`]}
          />
        );
      }
    });
    return selectedForm;
  };

  loadData = (props) => {
    const options = [];
    const subMenuOptions = [];
    let activeIndex = 0;
    let selectedFormId = -1;
    let selectedForm;
    let defaultData;
    if (props.previewSelectedFormId !== undefined) {
      selectedFormId = parseInt(props.previewSelectedFormId, 10);
    } else if (props.selectedFormId !== undefined) {
      const tokens = props.selectedFormId.split("Form_");
      selectedFormId = parseInt(tokens[1], 10);
    }
    _.map(this.props.leftMenuItems, (leftMenuItem, index) => {
      const report = _.find(
        this.props.reports,
        (a) => a.ReportID === leftMenuItem.ReportId
      );
      const option = {
        key: `SubMenuOption_${leftMenuItem.ReportId}_${index}`,
        value: index,
        text: `${leftMenuItem.MenuTitle}(${report.SearchResultCost})`,
      };
      subMenuOptions.push(option);
    });
    _.forEach(props.newFormsData, (formsData, index) => {
      const formId = formsData[0].FormId;
      const searchFormsData = props.searchFormsData;
      const option = {
        key: `FormOption_${formId}`,
        value: index,
        text: formsData[0].FormTitle,
      };
      options.push(option);

      if (selectedFormId === formId) {
        activeIndex = index;
        selectedForm = (
          <SearchFormTemplate
            key={`Form_${formId}_${index}`}
            formId={formId}
            formControls={formsData}
            style={{ padding: "5px" }}
            {...props}
            isLeftSearch
            defaultFormData={searchFormsData[`Form_${formId}`]}
          />
        );
        defaultData = option;
      }
    });
    if (this.state && this.state !== null) {
      this.setState({
        options,
        subMenuOptions,
        activeIndex,
        selectedForm,
        defaultData,
      });
    } else
      this.state = {
        options,
        subMenuOptions,
        activeIndex,
        selectedForm,
        defaultData,
      };
  };

  handleLeftMenuChanged = (e, data) => {
    this.props.onSearchTypeChanged(
      e,
      data.value,
      this.props.leftMenuItems[data.value].MenuId
    );
  };

  handleLeftFormChanged = (data) => {
    const selText = data.currentTarget.textContent;
    const selOption = _.find(this.state.options, (o) => o.text === selText);
    if (selOption !== undefined) {
      if (this.props.previewSelectedFormId !== undefined) {
        this.props.formsTabChanged(selOption.value);
      }
      const tokens = selOption.key.split("FormOption_");
      if (tokens.length > 1) {
        const formId = parseInt(tokens[1], 10);
        this.setState({
          activeIndex: selOption.value,
          selectedForm: this.getSelectedForm(formId),
        });
      } else this.setState({ activeIndex: selOption.value });
    }
  };

  render() {
    if (this.state === null || this.state.options === null) {
      return null;
    }
    return (
      <Table key={"left_new_search"} className={"left-search-background"}>
        <Table.Body>
          <Table.Row className="left-menu-selected">
            <Table.Cell
              // width={16}
              className={"icon-align-middle extra-large-font text-center"}
            >
              <Image inline src={SearchIcon} />
              Start New Search
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              {this.state.subMenuOptions && (
                <Dropdown
                  fluid
                  search
                  selectOnBlur={false}
                  key={`LeftSubMenu`}
                  selection
                  id={`LeftSubMenu`}
                  options={this.state.subMenuOptions}
                  name={`LeftSubMenu`}
                  value={this.props.searchTypeIndex}
                  label={"Left menu"}
                  onChange={(e, data) => {
                    this.handleLeftMenuChanged(e, data);
                  }}
                  // size="small"
                />
              )}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell
            // width={16}
            >
              {this.state.options && (
                <Dropdown
                  fluid
                  search
                  selectOnBlur={false}
                  key={`LeftForm`}
                  selection
                  id={`LeftForm`}
                  options={this.state.options}
                  name={`LeftForm`}
                  value={this.state.activeIndex}
                  label={"Search Type"}
                  onChange={(data) => {
                    this.handleLeftFormChanged(data);
                  }}
                  // size="small"
                />
              )}
              {this.state.selectedForm}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default SearchLeftForms;



// WEBPACK FOOTER //
// ./src/components/searches/SearchLeftForms.js